export let addIdToData = (data) => {
 return data?.map((data, index) => { return { ...data, id: index } })
}

export let convertBytesToGb = (bytes) => {
  const bytesInAGigabyte = 1024 * 1024 * 1024;
  return parseFloat((bytes / bytesInAGigabyte).toFixed(3));
}
